import { render, staticRenderFns } from "./departmentFrame.vue?vue&type=template&id=1062c7a5&scoped=true&"
import script from "./departmentFrame.vue?vue&type=script&lang=js&"
export * from "./departmentFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1062c7a5",
  null
  
)

export default component.exports